export default __webpack_public_path__ + "static/media/line-graph.ecda2d27.png";